// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { log } from 'src/consoleManager';
import postBeacon from 'src/networkManager';
import { getKeyNameStoreData, updateStoreData } from 'src/storage';
import { getAppSessionId, secondsToDays, getNextDateTime } from 'src/utils';
import { SESSION_KEY_STORAGE_TYPE, SESSION_STORAGE_TYPE } from 'src/utils/enum';
import { getSDKConfig } from 'src/utils/config';
import { priorityApiErrorEventLog } from './eventLog';
let priorityMaxRetriesCount = 5; // Number of retries for priority events from
let priorityRemainingRetriesCount = 5;
let priorityRetryBackoff = 500; // Retry delay in milliseconds (2 second)
let priorityDiscardOnFailure = false; // Do not discard priority events if retries fail
let priorityMaxBeaconsPerMinute = 120; // Maximum number of beacons allowed per minute
let priorityOfflineCacheFlushInterval = 7; //Flush offline cache every 7 days in seconds
const priorityProcessQueue = () => {
  if (
    window.spnGlobalConfig.spnBeaconNetworkStatus &&
    window.spnGlobalConfig.priorityBeaconExecutionStart == false
  ) {
    priorityConfigUpdate();
    priorityExecuteLocalStorage();
  }
};

const priorityConfigUpdate = () => {
  const sdkConfig = getSDKConfig();
  priorityMaxRetriesCount = sdkConfig?.priority?.max_retries || 5;
  priorityRemainingRetriesCount = sdkConfig?.priority?.max_retries || 5;
  priorityRetryBackoff = sdkConfig?.priority?.retry_backoff || 500;
  priorityDiscardOnFailure = sdkConfig?.priority?.discard_on_failure || false;
  const OfflineDays =
    sdkConfig?.priority?.offline_cache_flush_interval || 604800;
  const finalDays = secondsToDays(OfflineDays);
  priorityOfflineCacheFlushInterval = finalDays;
  priorityMaxBeaconsPerMinute =
    sdkConfig?.general?.rate_limit?.max_beacons_per_minute || 120;
  if (sdkConfig?.general?.rate_limit?.enabled == true) {
    const burstLimit = sdkConfig?.general?.rate_limit?.burst_limit || 50;
    priorityMaxBeaconsPerMinute += burstLimit;
  }
  priorityRemainingRetriesCount -= 1;
};

// current storage Execution
const priorityExecuteLocalStorage = () => {
  try {
    if (
      window.spnGlobalConfig?.maxRecordPerMinute >= priorityMaxBeaconsPerMinute
    ) {
      window.spnGlobalConfig.priorityBeaconExecutionStart = true;
      return;
    }
    if (!window.spnGlobalConfig.spnBeaconNetworkStatus) {
      return;
    }
    if (window.spnGlobalConfig.priorityBeaconExecutionStart) {
      return;
    }
    const sessionId = SESSION_STORAGE_TYPE.priority + getAppSessionId();
    const currentStoredata = localStorage.getItem(sessionId);
    const localStorageData = currentStoredata
      ? JSON.parse(currentStoredata)
      : [];
    if (localStorageData.length == 0) {
      window.spnGlobalConfig.priorityBeaconExecutionStart = true;
      return;
    }
    const currentTime = parseInt(localStorageData[0].currentTime);
    const payLoadBody = localStorageData[0].payLoadBody;
    const eventType = localStorageData[0].eventType;
    const offlineCacheNextDate = getNextDateTime(
      currentTime,
      priorityOfflineCacheFlushInterval
    );
    // offline cache time calculate
    if (currentTime > offlineCacheNextDate) {
      // remove from queue when current time greater then offline time
      const apiResponse = 200;
      priorityCleanCurrentSessionBeacons(apiResponse, sessionId);
      priorityHandleCurrentSessionNextBeaconExecute(apiResponse, sessionId);
    } else {
      const networkPromise = postBeacon(payLoadBody, eventType);
      networkPromise
        .then((apiResponse) => {
          priorityCleanCurrentSessionBeacons(apiResponse, sessionId);
          priorityHandleCurrentSessionNextBeaconExecute(apiResponse, sessionId);
        })
        .catch((e) => {
          log(e);
          priorityApiErrorEventLog(e, payLoadBody);
          if (
            window.spnGlobalConfig.spnBeaconNetworkStatus ||
            window?.navigator?.onLine
          ) {
            const apiResponse = 0;
            priorityCleanCurrentSessionBeacons(apiResponse, sessionId);
            priorityHandleCurrentSessionNextBeaconExecute(
              apiResponse,
              sessionId
            );
            //window.spnGlobalConfig.priorityBeaconExecutionStart = true;
          }
        });
    }
  } catch (e) {
    log(e);
    window.spnGlobalConfig.priorityBeaconExecutionStart = true;
  }
};

const priorityCleanCurrentSessionBeacons = (apiResponse, sessionId) => {
  try {
    //apiResponse == 200 || apiResponse == 0 &&
    const removeFromQueue = getRecordRemoveStatus(apiResponse);
    if (removeFromQueue) {
      const currentStoredata = localStorage.getItem(sessionId);
      const localStorageData = currentStoredata
        ? JSON.parse(currentStoredata)
        : [];
      if (localStorageData.length > 0) {
        localStorageData.shift();
        updateStoreData(sessionId, localStorageData);
      }
    }
  } catch (error) {
    log(error);
  }
};

const priorityHandleCurrentSessionNextBeaconExecute = (
  apiResponse,
  sessionId
) => {
  try {
    if (apiResponse == 200 || apiResponse == 0) {
      window.spnGlobalConfig.maxRecordPerMinute += 1;
      const intervalTime = apiResponse == 0 ? priorityRetryBackoff : 500;
      // when beacons pass
      const currentStoredata = localStorage.getItem(sessionId);
      const localStorageData = currentStoredata
        ? JSON.parse(currentStoredata)
        : [];
      if (
        localStorageData.length > 0 &&
        window.spnGlobalConfig.priorityBeaconExecutionStart == false
      ) {
        setTimeout(() => {
          priorityExecuteLocalStorage();
        }, intervalTime);
      } else {
        window.spnGlobalConfig.priorityBeaconExecutionStart = true;
      }
    }
  } catch (error) {
    log(error);
  }
};

/**
 * I'm trying to get the last stored data from the local storage and send it to the server.
 * I'm using the following code to get the last stored data:
 */

const priorityExecuteLastSessionData = () => {
  try {
    const sessionId = SESSION_STORAGE_TYPE.priority + getAppSessionId();
    const analyticsKeyList = getKeyNameStoreData(
      SESSION_KEY_STORAGE_TYPE.priority
    );
    const allLastSessionKey = [];
    if (analyticsKeyList) {
      const analyticsKeyListArr = JSON.parse(analyticsKeyList);
      if (
        Array.isArray(analyticsKeyListArr) &&
        analyticsKeyListArr.length > 0
      ) {
        analyticsKeyListArr.forEach((key) => {
          if (sessionId !== key) {
            allLastSessionKey.push(key);
          }
        });
      }
    }
    priorityHandleEachLastSessionData(allLastSessionKey);
  } catch (error) {
    log(error);
  }
};

const priorityHandleEachLastSessionData = (allLastSessionKey) => {
  try {
    if (!window.spnGlobalConfig.spnBeaconNetworkStatus) {
      return;
    }
    if (!allLastSessionKey || allLastSessionKey.length == 0) {
      return;
    }

    const eachLastSessionKey = allLastSessionKey[0];
    const lastStoredata = localStorage.getItem(eachLastSessionKey);
    const eachLastSessionDataArr = lastStoredata
      ? JSON.parse(lastStoredata)
      : [];

    if (eachLastSessionDataArr.length == 0) {
      priorityRemoveSessionKey(eachLastSessionKey, allLastSessionKey);
      return;
    }
    const currentTime = parseInt(eachLastSessionDataArr[0].currentTime);
    const payLoadBody = eachLastSessionDataArr[0].payLoadBody;
    const eventType = eachLastSessionDataArr[0].eventType;
    const offlineCacheNextDate = getNextDateTime(
      currentTime,
      priorityOfflineCacheFlushInterval
    );
    // offline cache time calculate
    if (currentTime > offlineCacheNextDate) {
      // remove from queue when current time greater then offline time
      const apiResponse = 200;
      priorityCleanEachBeacons(apiResponse, eachLastSessionKey);
      priorityHandleNextBeaconExecute(
        apiResponse,
        eachLastSessionKey,
        allLastSessionKey
      );
    } else {
      const networkPromise = postBeacon(payLoadBody, eventType);
      networkPromise
        .then((apiResponse) => {
          priorityCleanEachBeacons(apiResponse, eachLastSessionKey);
          priorityHandleNextBeaconExecute(
            apiResponse,
            eachLastSessionKey,
            allLastSessionKey
          );
        })
        .catch((e) => {
          log(e);
          priorityApiErrorEventLog(e, payLoadBody);
          if (
            window.spnGlobalConfig.spnBeaconNetworkStatus ||
            window?.navigator?.onLine
          ) {
            const apiResponse = 0;
            priorityCleanEachBeacons(apiResponse, eachLastSessionKey);
            priorityHandleNextBeaconExecute(
              apiResponse,
              eachLastSessionKey,
              allLastSessionKey
            );
          }
        });
    }
  } catch (e) {
    log(e);
  }
};

const priorityCleanEachBeacons = (apiResponse, eachLastSessionKey) => {
  try {
    if (apiResponse == 200 || apiResponse == 0) {
      const currentStoredata = localStorage.getItem(eachLastSessionKey);
      const eachLastSessionKeyData = currentStoredata
        ? JSON.parse(currentStoredata)
        : [];
      if (eachLastSessionKeyData.length > 0) {
        eachLastSessionKeyData.shift();
        updateStoreData(eachLastSessionKey, eachLastSessionKeyData);
      }
    }
  } catch (error) {
    log(error);
  }
};

const priorityHandleNextBeaconExecute = (
  apiResponse,
  eachLastSessionKey,
  allLastSessionKey
) => {
  try {
    if (apiResponse == 200 || apiResponse == 0) {
      window.spnGlobalConfig.maxRecordPerMinute += 1;
      // when beacons pass or fail
      const currentStoredata = localStorage.getItem(eachLastSessionKey);
      const localStorageData = currentStoredata
        ? JSON.parse(currentStoredata)
        : [];
      if (localStorageData.length > 0) {
        setTimeout(() => {
          priorityHandleEachLastSessionData(allLastSessionKey);
        }, 50);
      } else {
        priorityRemoveSessionKey(eachLastSessionKey, allLastSessionKey);
      }
    } else {
      priorityRemoveSessionKey(eachLastSessionKey, allLastSessionKey);
    }
  } catch (error) {
    log(error);
  }
};

const priorityRemoveSessionKey = (eachLastSessionKey, allLastSessionKey) => {
  if (localStorage.getItem(eachLastSessionKey)) {
    localStorage.removeItem(eachLastSessionKey);
  }
  priorityRemoveThisKeyFromList(eachLastSessionKey);
  allLastSessionKey.shift();
  priorityHandleEachLastSessionData(allLastSessionKey);
};

const priorityRemoveThisKeyFromList = (eachLastSessionKey) => {
  try {
    const analyticsKeyList = getKeyNameStoreData(
      SESSION_KEY_STORAGE_TYPE.priority
    );
    const analyticsKeyListData = analyticsKeyList
      ? JSON.parse(analyticsKeyList)
      : [];
    const keyPosition = analyticsKeyListData.indexOf(eachLastSessionKey);
    if (keyPosition > -1) {
      analyticsKeyListData.splice(keyPosition, 1);
      localStorage.setItem(
        SESSION_KEY_STORAGE_TYPE.priority,
        JSON.stringify(analyticsKeyListData)
      );
    }
  } catch (e) {
    log(e);
  }
  return true;
};

const getRecordRemoveStatus = (apiResponse) => {
  let removeFromQueue = false;
  if (apiResponse == 0 && priorityRemainingRetriesCount > 0) {
    removeFromQueue = false;
    priorityRemainingRetriesCount -= 1;
  } else {
    removeFromQueue = true;
    priorityRemainingRetriesCount = priorityMaxRetriesCount - 1;
  }
  if (apiResponse == 200) {
    removeFromQueue = true;
    priorityRemainingRetriesCount = priorityMaxRetriesCount - 1;
  }
  if (priorityDiscardOnFailure) {
    removeFromQueue = true;
  }
  return removeFromQueue;
};

export {
  priorityProcessQueue,
  priorityExecuteLocalStorage,
  priorityExecuteLastSessionData,
};
